import React from "react";
import {CONTRACTORS_SUBVIEW_MODEL} from "../../Model/Models";
import ApprovalFlowSubView from "../../../../DocumentationApprovalFlow/SubComponents/ApprovalFlowSubView";
import RequestSubView from "../../RequestDocumentation/SubComponents/RequestSubView";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: full stack
 */
const DocumentationView = ({ subView, handleSubViewChange,search,setSearch, setSimpleSearch,
                               DEV, permission, searchElement, setSearchElement, deleteApprovalFlowShow,option,
                               setIsAllChecked, setDeleteApprovalFlowShow, selectedList, setSelectedList,
                               viewType, userTypeId
}) => {

    return (
        <>
            {subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW && (
                <ApprovalFlowSubView
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    DEV={DEV}
                    option={option}
                    permission={permission}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    deleteApprovalFlowShow={deleteApprovalFlowShow}
                    setIsAllChecked={setIsAllChecked}
                    setDeleteApprovalFlowShow={setDeleteApprovalFlowShow}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    viewType={viewType}
                    userTypeId={userTypeId}
                />
            )}

            {subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.REQUESTS && (
                <RequestSubView
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    DEV={DEV}
                    permission={permission}
                    option={option}
                    viewType={viewType}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    userTypeId={userTypeId}
                    setIsAllChecked={setIsAllChecked}
                />
            )}
        </>
    );
};

export default DocumentationView
